// extracted by mini-css-extract-plugin
export default {"listItem":"listItem_listItem__hSKJ+","title":"listItem_title__dYjlk","userPic":"listItem_userPic__kony3","post":"listItem_post__Fl5fu","comment":"listItem_comment__nmsLL"};